export const formatJobMetadataValue = (value: unknown): string => {
  if (value === null || typeof value === 'undefined') {
    return '';
  }

  if (typeof value === 'object') {
    return JSON.stringify(value) ?? '';
  }

  return String(value);
};
